import { useBoolean } from 'ahooks'
import { Button, Modal } from 'antd'

import { queryFreezeRecordApi } from '@eastcoal/api/trade/unfreezeApplyMember/queryFreezeRecord'

import { RemoteTable } from '@eastcoal/common/components/RemoteTable'

import { UnfreezeApplyListTableProps } from './interface'

const freezeColumns: UnfreezeApplyListTableProps['columns'] = [
  {
    dataIndex: 'sort',
    title: '序号',
    align: 'center',
    width: 60
  },
  {
    dataIndex: 'title',
    title: '资金冻结项',
    width: 420
  },
  {
    dataIndex: 'type',
    title: '资金类型',
    width: 80
  },
  {
    dataIndex: 'amount',
    title: '冻结金额',
    valueType: 'digit',
    align: 'right'
  },
  {
    dataIndex: 'applyTime',
    title: '冻结时间',
    width: 140
  }
]

export const AccountStatisticWithUnfreezeDetailButton = () => {
  const [open, openActions] = useBoolean(false)

  return (
    <>
      <Modal
        destroyOnHidden
        cancelText='关闭'
        closable={false}
        okButtonProps={{ hidden: true }}
        open={open}
        title='冻结中金额明细'
        width={1000}
        onCancel={openActions.setFalse}
      >
        <RemoteTable
          columns={freezeColumns}
          pagination={false}
          rowKey='sort'
          scroll={{ y: 488 }}
          api={() => {
            return queryFreezeRecordApi().then(detail =>
              detail.map((item, index) => ({ ...item, sort: `${index + 1}` }))
            )
          }}
        />
      </Modal>
      <Button size='small' type='link' onClick={openActions.setTrue}>
        明细
      </Button>
    </>
  )
}
